<template>
    <div class='dataapi_wrap'>
        <StockData :menuList="menuList" @changeActive="changeActive" @changeItemActive="changeItemActive" :activeIndex="0">
        <div slot="stock_detail" class="stock_detail">
            <ContentTop>
                <span slot="stockName">{{stockName}}</span>
                <div slot="stockDescription">{{stockDescription}}</div>
            </ContentTop>
            <div class="main_mid">
                <div class="top_tips "><span class="ml20">选择股票</span></div>
                <div class="serch_lab flex-between left3">
                    <div class="is_choose">已选股票</div>
                    <div class="serch_box flex-between">
                        <el-autocomplete  v-model="options" prefix-icon="el-icon-search" placeholder="股票代码 / 股票名称" :fetch-suggestions="querySearch" :trigger-on-focus="false" @select="selectArr"></el-autocomplete>
                    </div>
                </div>
                <div class="serch_list left3 flex-start">
                    <span v-show="isShowTips" class="select_tips">请在右上角查询并选择股票数据...</span>
                    <div class="list_item flex-between" :key="index" v-for="(item,index) in securityList"><span>{{item}}</span><span class="el-icon-circle-close" @click="removeItem(index)" :key="index"></span></div>
                    <div class="delete_btn" v-show="!isShowTips" @click="clearSelectArr"><el-button type="danger" icon="el-icon-delete" circle></el-button></div>
                </div>
                <div class="top_tips mat40"><span class="ml20">选择时间区间</span></div>
                <div class="time_select left3">
                    <el-date-picker range-separator='至' start-placeholder='开始日期' :picker-options='pickerOptions'
                                    end-placeholder='结束日期' unlink-panels type='daterange' value-format='yyyy-MM-dd'
                                    v-model='timeRangeValue'></el-date-picker>
                </div>
                <div class='top_tips mat40'><span class='ml20'>调整数据</span></div>
                <div class='select_type left3'>
                    <el-radio-group v-model='selectTypeList.selectId'>
                        <span v-for='item in selectTypeList.selectItem' :key='item.id' class='mr70'><el-radio
                            class='select_item' :key='item.id' :label='item.id'>{{ item.title }}</el-radio></span>
                    </el-radio-group>
                </div>
                <div class='but_btn'>
                    <div class='donload_btn' @click='queryTheData'>查询数据</div>
                    <div></div>
                </div>
            </div>
            <!-- 数据预览-->
            <DataPreview
                v-if='whetherToShowAPreview'
                ref='dataPreview'
                :down-load-data='downLoadData'
                api-url='/ms_resource/stock/preview'
                :queryParameters='queryParameters'
            ></DataPreview>
        </div>
        </StockData>
    </div>
</template>


<script>
import { getStockdetail, getStockMenu, getStocksearch } from '../../utils/api';
import DataPreview from '@/components/common/DataPreview';

export default {
    components: {
        DataPreview
    },
    data() {
        return {
            menuList: [],
            selectTypeList: {
                selectId: 0,
                selectItem: [
                    { id: 0, title: '不复权' },
                    { id: 1, title: '前复权' },
                    { id: 2, title: '后复权' }
                ]
            },
            securityList:[],
            activeIndex:0,
            activeItemIndex:3,
            download:'数据下载',
            isActive:1,
            stockDescription: '',
            keyword: '',
            options: '',
            selectOptions: [],
            timeRangeValue: [],
            stockName: '',
            pickerOptions: {
                disabledDate(data) {
                    return data && data.valueOf() >= new Date();
                }
            },
            queryParameters: {},
            whetherToShowAPreview: true
        }
    },
    created(){
        this.getLeftStokeMenu()
        this.getStockdetail()
    },
    computed:{
        isShowTips(){
            return this.securityList.length <= 0 ? true : false
        }
    },
    methods:{
        // 获取左边侧边栏数据
        getLeftStokeMenu(){
            getStockMenu().then(res => {
                this.menuList = res.data
            }).catch(err=>{})
        },

        // el-submenu改变时获取index
        changeActive(index){
            this.activeIndex = index
        },

        // el-menu-item改变时操作
        changeItemActive(index){
            this.activeItemIndex = index;
            this.whetherToShowAPreview = false;
            this.getStockdetail();
            this.securityList = []
            this.timeRangeValue = []
            this.selectTypeList.selectId = 0
        },

        // 获取文本内容
        getStockdetail(){
            getStockdetail({menuId:this.activeItemIndex}).then(res=>{
            this.stockDescription = res.data.description
            this.stockName = res.data.title
            }).catch(err=>{})
        },

        // 模糊查询
        async querySearch(queryString, cb) {
            await getStocksearch({ keyword: queryString,menuId:this.activeItemIndex })
            .then(res => {
                cb(res.data);
            })
            .catch(err => {});
        },

        // 获取所选的数组
        selectArr(item){
            // 不存在
            if(this.securityList.indexOf(item.value) == -1){
                if(item != ''){
                    this.securityList.push(item.value);
                    this.options = '';
                }
            }
            // 存在
            else {
                this.options = '';
                this.$message.warning('不能重复选择股票');
            }
        },
        //查询数据
        queryTheData() {
            this.whetherToShowAPreview = true;
            if (this.securityList.length === 0) return this.$message.warning('请选择股票');
            if (!this.timeRangeValue[1] || !this.timeRangeValue[0]) return this.$message.warning('请选择时间区间');
            this.queryParameters = {
                adjust: this.selectTypeList.selectId,
                afterTime: this.timeRangeValue[1],
                beforeTime: this.timeRangeValue[0],
                codes: this.securityList.map(item => {
                    let index = item.indexOf(' ');
                    return item.substring(0, index);
                }).join(','),
                menuId: this.activeItemIndex
            };
            setTimeout(() => {
                this.$refs.dataPreview.queryTheData();
            });
        },
        currentChange(current) {
            this.previewPagination.page = current;
            this.queryTheData();
        },
        // 下载数据
        downLoadData() {
            // 字符串截取
            let selectCodes = this.securityList.map(item => {
                let index = item.indexOf(' ');
                return item = item.substring(0, index);
            });
            // 路径拼接
            let select = selectCodes.map(item => {
                return `codes=${item}&`;
            }).toString().split(',').join('')

            if(this.timeRangeValue[0] == undefined || !this.timeRangeValue[1] == undefined || selectCodes.length <= 0){
                this.$message.error('时间和股票必选')
            }else{
                location.href = `${this.$config.BASE_URL}/stock/export?${select}beforeTime=${this.timeRangeValue[0]}&afterTime=${this.timeRangeValue[1]}&adjust=${this.selectTypeList.selectId}&menuId=${this.activeItemIndex}`
                this.download = '数据下载中...'
                this.isActive = 2
                setTimeout(() => {
                    this.download = '数据下载'
                    this.isActive = 1
                },2000)
            }
        },

        // 删除单个选项
        removeItem(id) {
            this.securityList.splice(id, 1);
        },

        // 清空所有选项
        clearSelectArr() {
            this.securityList = [];
        }
    }
}
</script>
<style scoped lang='scss'>
.mrl10 {
    margin-left: 10px;
}

.icon-xitongxinxi {
    font-size: 32px;
    color: #5377F7;
}

.icon-tandem-full {
    font-size: 32px !important;
}
.enter1:hover{
    opacity: 0.8;
    cursor: pointer;
}
.but_btn{
    width: 35%;
  // background: #888888;
}
.top_tips{
    margin-bottom: 30px;
    height: 33px;
    line-height: 33px;
    font-size: 26px;
    color: #271B63;
    font-weight: bold;
    border-left: 8px solid #002D72;
}
.donload_btn:hover{
    opacity: 0.8;
    cursor: pointer;
}

.dataapi_wrap{
    .stock_detail{
        padding-bottom: 100px;
        .main_mid {
            position: relative;
            width: 90%;
            padding: 30px 80px 80px 80px;
            border-radius: 10px 10px 0px 0px;
            margin-left: -1%;
            margin-top: 30px;
            background: #fff;

            .dataPreviewTitle {
                display: flex;
                align-items: center;

                .download {
                    margin-left: 20px;
                    cursor: pointer;
                    margin-bottom: 30px;
                    color: #271B63;
                    font-size: 16px;
                    display: flex;
                    align-items: center;

                    i {
                        margin-right: 5px;
                        background: rgb(240, 240, 255);
                        font-size: 26px;
                    }
                }
            }

            .el-pagination {
                position: absolute;
                bottom: 20px;
                left: 50%;
                transform: translateX(-50%);
            }

            .serch_list {
                min-height: 140px;
                border: 1px solid #002D72;
                margin-top: 30px;
                padding: 0 0 30px;
                display: flex;
                flex-wrap: wrap;

                .list_item {
                    width: 15%;
                    height: 50px;
                    font-size: 18px;
                    color: #271B63;
                    margin:30px 2.5% 0 2.5%;
                }
                .list_item{
                    opacity: 0.8;
                    cursor: pointer;
                }
            }
            .serch_box{
                /deep/ .el-input__inner{
                width: 300px;
                margin-right: 5px;
                }
            }
            .time_select{
                width: 400px;
                /deep/ .el-icon-date{
                font-size: 20px;
                }
            }
        }
    }
}
</style>
